import { render } from "./UploadCreditNotes.vue?vue&type=template&id=0b302322"
import script from "./UploadCreditNotes.vue?vue&type=script&lang=js"
export * from "./UploadCreditNotes.vue?vue&type=script&lang=js"

import "./UploadCreditNotes.vue?vue&type=style&index=0&id=0b302322&lang=css"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__